export default __webpack_public_path__ + "static/Plots0005-a07f9bcfd72a5b0d0c90c82b0cf983fe.jpg";